module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    on: {
      "click": _vm.previousSalesView
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": ""
    }
  }, [_c('h2', [_vm._v("B/L ( NON-US )")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  })], 1)], 1), _vm._v(" "), (_vm.BLRaised.conFclBLNonUsId != '' || _vm.clientList.length > 0) ? _c('div', [_c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [(_vm.BLRaised.conFclBLNonUsId == '') ? _c('label', {
    attrs: {
      "for": "fclConsoMultipleClientId"
    }
  }, [_vm._v("Client Name")]) : _vm._e(), _vm._v(" "), (_vm.BLRaised.conFclBLNonUsId == '') ? _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "fclConsoMultipleClientId",
      "option-value": "fclConsoMultipleClientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.BLRaised.fclConsoMultipleClientId),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "fclConsoMultipleClientId", $$v)
      },
      expression: "BLRaised.fclConsoMultipleClientId"
    }
  }) : _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientName"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.BLRaised.clientName),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "clientName", $$v)
      },
      expression: "BLRaised.clientName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("B/L Stage")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.blStageList,
      "option-value": "blStageVal",
      "option-text": "blStageTxt",
      "placeholder": "Select B/L Stage"
    },
    model: {
      value: (_vm.BLRaised.blStage),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "blStage", $$v)
      },
      expression: "BLRaised.blStage"
    }
  }), _vm._v(" "), (!_vm.BLRaised.blStage) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.blStage))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("CONSIGNOR")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', [_vm._v("CONSIGNEE ( OR ORDER)")])])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    ref: "myTextEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.BLRaised.consignor),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "consignor", $$v)
      },
      expression: "BLRaised.consignor"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.consignor) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.consignor))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    ref: "myTextEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.BLRaised.consignee),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "consignee", $$v)
      },
      expression: "BLRaised.consignee"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.consignee) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.consignee))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.BLRaised.notifyList), function(singleInput, index) {
    return _c('md-layout', {
      key: index,
      staticStyle: {
        "margin-top": "3%"
      },
      attrs: {
        "md-flex": "30"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "60"
      }
    }, [_c('label', [_vm._v(_vm._s(_vm.notifyArray[index]) + " Notify Party")])]), _vm._v(" "), (index > 1) ? _c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      staticStyle: {
        "min-height": "20px",
        "height": "20px"
      },
      on: {
        "click": function($event) {
          _vm.removeNotify(index)
        }
      }
    }, [_c('md-icon', [_vm._v("close")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "70"
      }
    }, [_c('quill-editor', {
      ref: "myTextEditor",
      refInFor: true,
      model: {
        value: (singleInput.inputValue),
        callback: function($$v) {
          _vm.$set(singleInput, "inputValue", $$v)
        },
        expression: "singleInput.inputValue"
      }
    })], 1)], 1)], 1)
  })), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    staticClass: "showMoreData",
    on: {
      "click": _vm.addNotify
    }
  }, [_vm._v("Add Notify")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Bill of Lading No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "billLading",
      "name": "billLading"
    },
    model: {
      value: (_vm.BLRaised.billLading),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "billLading", $$v)
      },
      expression: "BLRaised.billLading"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.billLading) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.billLading))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipment Reference Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "shippingReferenceNum",
      "name": "shippingReferenceNum"
    },
    model: {
      value: (_vm.BLRaised.shippingReferenceNum),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "shippingReferenceNum", $$v)
      },
      expression: "BLRaised.shippingReferenceNum"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.shippingReferenceNum) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.shippingReferenceNum))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Type of Move")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "typeMove",
      "name": "typeMove"
    },
    model: {
      value: (_vm.BLRaised.typeMove),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "typeMove", $$v)
      },
      expression: "BLRaised.typeMove"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.typeMove) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.typeMove))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("No. of Original B/L")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "originalBill",
      "name": "originalBill"
    },
    model: {
      value: (_vm.BLRaised.originalBill),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "originalBill", $$v)
      },
      expression: "BLRaised.originalBill"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.originalBill) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.originalBill))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Pre­Carriage By")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "",
      "name": ""
    },
    model: {
      value: (_vm.BLRaised.preCarriage),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "preCarriage", $$v)
      },
      expression: "BLRaised.preCarriage"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.preCarriage) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.preCarriage))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Place of Acceptance/Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "datetime",
      "format": "YYYY-MM-DD hh:mm ",
      "minute-step": 1,
      "id": "acceptanceDate"
    },
    model: {
      value: (_vm.BLRaised.acceptanceDate),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "acceptanceDate", $$v)
      },
      expression: "BLRaised.acceptanceDate"
    }
  }), _vm._v(" "), (!_vm.BLRaised.acceptanceDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.acceptanceDate))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Transport Mode")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "modeMean",
      "name": "modeMean"
    },
    model: {
      value: (_vm.BLRaised.modeMean),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "modeMean", $$v)
      },
      expression: "BLRaised.modeMean"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.modeMean) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.modeMean))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Vessel/Voy")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "vesselVoy",
      "name": "vesselVoy"
    },
    model: {
      value: (_vm.BLRaised.vesselVoy),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "vesselVoy", $$v)
      },
      expression: "BLRaised.vesselVoy"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.vesselVoy) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.vesselVoy))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Route/Place of Transhipment(If Any")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "routePlace",
      "name": "routePlace"
    },
    model: {
      value: (_vm.BLRaised.routePlace),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "routePlace", $$v)
      },
      expression: "BLRaised.routePlace"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.routePlace) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.routePlace))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Port of Loading")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "portLoad",
      "name": "portLoad"
    },
    model: {
      value: (_vm.BLRaised.portLoad),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "portLoad", $$v)
      },
      expression: "BLRaised.portLoad"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.portLoad) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.portLoad))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Port of Discharge")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "portDischarge",
      "name": "portDischarge"
    },
    model: {
      value: (_vm.BLRaised.portDischarge),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "portDischarge", $$v)
      },
      expression: "BLRaised.portDischarge"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.portDischarge) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.portDischarge))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Final Place of Delivery")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "placeDilievery",
      "name": "placeDilievery"
    },
    model: {
      value: (_vm.BLRaised.placeDilievery),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "placeDilievery", $$v)
      },
      expression: "BLRaised.placeDilievery"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.placeDilievery) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.placeDilievery))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "85"
    }
  }, [_c('label', [_vm._v("Description of Packages and Goods")])])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "85"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    ref: "myTextEditor",
    staticStyle: {
      "width": "900px !important"
    },
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.BLRaised.descriptionGood),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "descriptionGood", $$v)
      },
      expression: "BLRaised.descriptionGood"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.descriptionGood) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.descriptionGood))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Description of Charges")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Prepaid")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Collect")])])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.BLRaised.desCharges),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "desCharges", $$v)
      },
      expression: "BLRaised.desCharges"
    }
  })], 1)], 1), _vm._v(" "), (!_vm.BLRaised.desCharges) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.desCharges))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.BLRaised.prepaid),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "prepaid", $$v)
      },
      expression: "BLRaised.prepaid"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.prepaid) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.prepaid))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.BLRaised.collect),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "collect", $$v)
      },
      expression: "BLRaised.collect"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.collect) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.collect))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Place")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PlaceList,
      "option-value": "PlaceVal",
      "option-text": "PlaceTxt",
      "placeholder": "Select Pridel Branch Name"
    },
    model: {
      value: (_vm.BLRaised.placeBranch),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "placeBranch", $$v)
      },
      expression: "BLRaised.placeBranch"
    }
  }), _vm._v(" "), (!_vm.BLRaised.placeBranch) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.placeBranch))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Delievery Agent")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.AgentList,
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "placeholder": "Select Delievery Agent"
    },
    model: {
      value: (_vm.BLRaised.delieveryAgent),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "delieveryAgent", $$v)
      },
      expression: "BLRaised.delieveryAgent"
    }
  }), _vm._v(" "), (!_vm.BLRaised.delieveryAgent) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.delieveryAgent))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Total")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "total",
      "name": "total"
    },
    model: {
      value: (_vm.BLRaised.total),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "total", $$v)
      },
      expression: "BLRaised.total"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.total) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.total))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px",
    attrs: {
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addBLRaised
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1), _vm._v(" "), (_vm.containerDetail.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Container Detail")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "clientSB"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllContainers),
      expression: "selectAllContainers"
    }],
    attrs: {
      "type": "checkbox",
      "indeterminate": _vm.isIndeterminate
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllContainers) ? _vm._i(_vm.selectAllContainers, null) > -1 : (_vm.selectAllContainers)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectAllContainers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllContainers = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAllContainers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllContainers = $$c
        }
      }, _vm.toggleSelectAll]
    }
  })]), _vm._v(" "), _c('th', [_vm._v("Container No")]), _vm._v(" "), _c('th', [_vm._v("Container Type")]), _vm._v(" "), _c('th', [_vm._v("Seal No")]), _vm._v(" "), _c('th', [_vm._v("Gross Weight")]), _vm._v(" "), _c('th', [_vm._v("Measurement")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.containerDetail), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.selected),
        expression: "item.selected"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": item.containerWithSplit == 1
      },
      domProps: {
        "checked": Array.isArray(item.selected) ? _vm._i(item.selected, null) > -1 : (item.selected)
      },
      on: {
        "change": [function($event) {
          var $$a = item.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (item.selected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (item.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(item, "selected", $$c)
          }
        }, _vm.updateSelectAll]
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.fclConcontainerNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.containerType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.customSealNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.conGrossWeight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.measurement))])])
  }))])]), _vm._v(" "), (_vm.containerDetail.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "alert alert-info"
  }, [_c('strong', [_vm._v("Container Selection:")]), _vm._v(" Use the checkboxes to select individual containers or use the controls below for bulk operations. \n                  Selected containers can be used for specific operations. Containers with split status are disabled.\n                ")]), _vm._v(" "), (!_vm.hasSelectedContainers) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('strong', [_vm._v("Warning:")]), _vm._v(" Please select at least one container to proceed.\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "size": "sm",
      "variant": "info"
    },
    on: {
      "click": function($event) {
        _vm.selectAllContainers = true;
        _vm.toggleSelectAll()
      }
    }
  }, [_vm._v("\n                      Select All\n                    ")]), _vm._v(" "), _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "size": "sm",
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.selectAllContainers = false;
        _vm.toggleSelectAll()
      }
    }
  }, [_vm._v("\n                      Deselect All\n                    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                      Selected: " + _vm._s(_vm.selectedContainersCount) + " of " + _vm._s(_vm.selectableContainersCount) + " containers\n                    ")])])])]) : _vm._e()]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), (_vm.nonUsBlTable.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Client BL Details")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('Filter-Agency-Modal'), _vm._v(" "), _c('FilterCBModal'), _vm._v(" "), _c('ClientCard'), _vm._v(" "), _c('ShipmentTrackCard'), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "clientSB"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("BL Stage")]), _vm._v(" "), _c('th', [_vm._v("Print")]), _vm._v(" "), _c('th', [_vm._v("Download Word")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.nonUsBlTable), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.viewEditBLNonUs(item)
        }
      }
    }, [_vm._v(_vm._s(item.clientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.blStage))]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.Print(item.uploadBLCon)
        }
      }
    }, [_c('md-icon', [_vm._v("print")])], 1)], 1), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.downloadWord(item.conFclBLNonUsId)
        }
      }
    }, [_c('md-icon', [_vm._v("cloud_download")])], 1)], 1)])
  }))])])], 1) : _vm._e(), _vm._v(" "), (_vm.BLRaised.conFclBLNonUsId == '' && _vm.clientList.length == 0) ? _c('hr', {
    staticClass: "hr-s"
  }) : _vm._e(), _vm._v(" "), (_vm.BLRaised.conFclBLNonUsId == '' && _vm.clientList.length == 0) ? _c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px",
    attrs: {
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.proceedAws
    }
  }, [_vm._v("Proceed to AMS Filling")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-967c714c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ffExportCon/conBLNonUs.vue
// module id = 2803
// module chunks = 0